import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["loading"]
const _hoisted_2 = {
  key: 0,
  class: "control__icon icon--left"
}
const _hoisted_3 = ["value", "type", "placeholder", "disabled"]
const _hoisted_4 = {
  key: 1,
  class: "control__icon icon--right"
}
const _hoisted_5 = {
  key: 0,
  class: "bs-field__validation"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_loader = _resolveComponent("bs-loader")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bs-field", {
            'bs-field--medium': _ctx.size === 'medium',
            'bs-field--big': _ctx.size === 'big',
            'bs-field--icon-left': Boolean(_ctx.$slots['icon-left']),
            'bs-field--icon-right': Boolean(_ctx.$slots['icon-right']) || _ctx.loading,
            'bs-field--disabled': _ctx.disabled,
            'bs-field--invalid': _ctx.invalid
        }]),
    loading: _ctx.loading
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["bs-field__control", {
                'control--focused': _ctx.isFocused
            }])
    }, [
      (_ctx.$slots['icon-left'])
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "icon-left")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("input", {
        ref: "inputRef",
        value: _ctx.modelValue,
        type: _ctx.type,
        placeholder: _ctx.placeholder,
        disabled: _ctx.disabled || _ctx.loading,
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
        onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
        onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args)))
      }, null, 40, _hoisted_3),
      (_ctx.$slots['icon-right'] || _ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_bs_loader, { key: 0 }))
              : (_ctx.$slots['icon-right'])
                ? _renderSlot(_ctx.$slots, "icon-right", { key: 1 })
                : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (Boolean(_ctx.validationErrors.length))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.getValidationMessage(_ctx.validationErrors)), 1))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}